import { Component, computed, inject, input, output } from '@angular/core';
import { LucideBellRing, LucideDynamicIcon, LucideX } from '@lucide/angular';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { TextDirective } from '../../../typography/text.directive';
import { NotificationComponent } from '../notification.component';
import { JoiiIcon } from '../../../icons/lucide/icon';

@Component({
  selector: 'joii-notification-simple',
  host: {
    '[attr.data-type]': 'type()',
  },
  template: `
    <svg id="icon" [lucideIcon]="icon()" [size]="20" />
    <span id="text" joii-text color="tint1" [size]="4">{{ text() }}</span>
    @if (showCloseButton()) {
      <button
        joii-button
        type="button"
        id="close-button"
        [iconOnly]="true"
        size="sm"
        variant="secondary"
        [icon]="closeIcon()"
        aria-label="Close notification"
        (click)="closeClick.emit(); $event.preventDefault(); $event.stopPropagation()"
      ></button>
    }
  `,
  styleUrl: './notification-layout-simple.component.css',
  imports: [LucideDynamicIcon, TextDirective, ButtonComponent],
})
export class NotificationLayoutSimpleComponent {
  Notification = inject(NotificationComponent, { optional: true });
  type = computed(() => this.Notification?.type() ?? 'info');
  icon = input<JoiiIcon>(LucideBellRing);
  closeIcon = input<JoiiIcon>(LucideX);
  showCloseButton = input(true);
  text = input.required<string>();
  closeClick = output<void>();
}
